export const TITLE = 'pas_control.title';
export const DELIVERY_METHOD_QUESTION = 'pdp.delivery_method.question';
export const AVAILABLE_FOR_OTHER_DATES =
  'pdp.delivery_method.available_for_other_dates';
export const AVAILABLE_FOR_OTHER_PRODUCTS =
  'pdp.delivery_method.available_for_other_products';
export const CHANGE_DELIVERY_STORE =
  'pdp.delivery_method.change_delivery_store';
export const CHANGE_STORE = 'pdp.delivery_method.change_store';
